(() => {
  const disclosureSelector = '.dm-keyword-mega-menu__variant-disclosure[open]';
  const megaDisclosureSelector = '.dm-keyword-mega-disclosure[open]';

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Escape' || !(event.target instanceof Element)) {
        return;
      }

      const disclosure = event.target.closest(disclosureSelector);

      if (disclosure) {
        event.preventDefault();
        event.stopImmediatePropagation();
        disclosure.open = false;

        queueMicrotask(() => {
          disclosure.querySelector(':scope > summary')?.focus({ preventScroll: true });
        });

        return;
      }

      const megaDisclosure = event.target.closest(megaDisclosureSelector);

      if (!megaDisclosure) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      megaDisclosure.open = false;

      queueMicrotask(() => {
        megaDisclosure.querySelector(':scope > summary')?.focus({ preventScroll: true });
      });
    },
    true
  );
})();

